module.exports = __webpack_public_path__ + "img/logo-1.f6d74e2b.png";